import { Download, Share2, X } from "lucide-react";
import { useFormatAmount } from "../../hooks/useFormatAmount";
import { useFormattedDate } from "../../hooks/useFormattedDate";

const LoanTransaction = ({ closeLoanTransaction, transaction }) => {
  const formatAmount = useFormatAmount();
  const formattedDate = useFormattedDate();

  function formatTimeFromISO(dateString) {
    const date = new Date(dateString);
    return date.toLocaleTimeString("en-KE", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }

  return (
    <div
      onClick={closeLoanTransaction}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[880px] h-[500px] rounded-[10px] p-[20px] relative bg-white overflow-y-auto shadow-lg"
      >
        {/* Close Button */}
        <div
          onClick={closeLoanTransaction}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>

        {/* Title */}
        <p className="font-semibold text-center text-[#000000] text-[18px] mb-[20px]">
          Loan Transaction Details
        </p>

        {/* General Transaction Details */}
        <div className="mb-[20px] border rounded-[8px] p-[15px] bg-[#F9FAFB]">
          <p className="text-[15px] font-semibold text-[#000000] mb-[10px]">
            General Transaction Details
          </p>
          <div className="grid grid-cols-2 gap-y-[10px] gap-x-[20px] text-[14px]">
            <p>
              <span className="font-semibold">Transaction ID:</span>{" "}
              {transaction?.public_id || "--"}
            </p>
            <p>
              <span className="font-semibold capitalize">
                Transaction Type:
              </span>{" "}
              {transaction?.type || transaction?.transactionType || "--"}
            </p>
            <p>
              <span className="font-semibold">Amount:</span>{" "}
              {formatAmount(transaction?.amount) || "0.00"}
            </p>
            <p>
              <span className="font-semibold">Balance:</span>{" "}
              {formatAmount(transaction?.balance) || "0.00"}
            </p>
            <p>
              <span className="font-semibold capitalize">Payment Mode:</span>{" "}
              {transaction?.method || transaction?.paymentMethod || "--"}
            </p>
            <p>
              <span className="font-semibold">Reference Number:</span>{" "}
              {transaction?.paymentReference || "--"}
            </p>
            <p>
              <span className="font-semibold">Transaction Date:</span>{" "}
              {formattedDate(transaction?.paymentDate) || "--"}
            </p>
            <p>
              <span className="font-semibold">Transaction Time:</span>{" "}
              {formatTimeFromISO(transaction?.paymentDate) || "--"}
            </p>
            <p>
              <span className="font-semibold">Transaction Reason:</span> Loan
              repayment
            </p>
          </div>
        </div>

        {/* M-Pesa Details (only if payment mode is M-Pesa) */}
        {transaction?.method?.toLowerCase() === "mpesa" && (
          <div className="border rounded-[8px] p-[15px] bg-[#FFF9F9]">
            <p className="text-[15px] font-semibold text-[#28a745] mb-[10px]">
              M-Pesa Details
            </p>
            <div className="grid grid-cols-2 gap-y-[10px] gap-x-[20px] text-[14px]">
              <p>
                <span className="font-semibold">Sender Name:</span>{" "}
                {transaction?.senderName || "--"}
              </p>
              <p>
                <span className="font-semibold">Sender Phone:</span>{" "}
                {transaction?.senderPhone || "--"}
              </p>
              <p>
                <span className="font-semibold">M-Pesa Reference:</span>{" "}
                {transaction?.paymentReference || "--"}
              </p>
            </div>
          </div>
        )}
        {/* Action Buttons */}
        <div className="flex items-center justify-end gap-[10px] mt-[30px]">
          <button
            onClick={() => console.log("Download receipt for", transaction?.id)}
            className="flex items-center gap-[6px] bg-[#000000] hover:bg-[#003d7a] text-white text-[14px] font-medium px-[15px] py-[8px] rounded-[6px]"
          >
            <Download size={16} /> Download Receipt
          </button>
          <button className="flex items-center gap-2 px-4 py-2 bg-[#00A35C] text-white text-sm font-semibold rounded-md hover:bg-[#007a46]">
            <Share2 size={16} /> Share Receipt
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoanTransaction;
